// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2196":"ee8b1517","3662":"29107295"}[chunkId] || chunkId) + "." + {"442":"50d6e27f702a169b","490":"1f722ecd94468cfd","2196":"de5f8e431f1123ad","3662":"396b395d4364cf2b","8078":"dd4a304f5c7e9773","8537":"ba5c320d82573722"}[chunkId] + ".js";
};